import { Grid } from '@mui/material';
import { ODSUploadToCloud } from '@telekom-ods/react-icons';
import { ODSUploadBox, type ODSUploadBoxProps } from '@telekom-ods/react-ui-kit';
import type { ReactNode } from 'react';
import { useIntl } from 'react-intl';

interface UploadFileProps {
  title?: string;
  description?: string;
  infoText?: string;
  icon?: ReactNode;
  onFileUpload?: ODSUploadBoxProps['onFileUpload'];
  disabled?: boolean;
}

export const UploadFile = ({
  title,
  description = '',
  infoText = '',
  icon = <ODSUploadToCloud />,
  onFileUpload,
  disabled = false,
}: UploadFileProps) => {
  const intl = useIntl();
  const resolvedTitle = title ?? intl.formatMessage({ id: 'uploadFile' });

  return (
    <Grid
      item
      xs={12}
      sx={{ marginBottom: 2, width: '100%' }}
    >
      <ODSUploadBox
        title={resolvedTitle}
        description={description}
        icon={icon}
        infoText={infoText}
        {...(onFileUpload && { onFileUpload })}
        buttonProps={
          {
            disabled: disabled,
            label: intl.formatMessage({ id: 'clickToUpload' }),
          } as unknown as NonNullable<ODSUploadBoxProps['buttonProps']>
        }
      />
    </Grid>
  );
};
